import React from "react";
import { Card, Box, Typography, Chip, CardActionArea } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useNavigate } from "react-router-dom";
import { PIPELINE_ROUTE } from "../../hooks/usePipeline";

interface PipelineCardProps {
  entryCount: number;
  overdueCount: number;
}

/** Dashboard folder for Lead/Active entries; always shown before the year folders */
export const PipelineCard: React.FC<PipelineCardProps> = ({
  entryCount,
  overdueCount,
}) => {
  const navigate = useNavigate();

  return (
    <Card
      elevation={3}
      className="tile"
      sx={{
        transition: "transform 0.2s, box-shadow 0.2s",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        border: overdueCount > 0 ? "1px solid" : undefined,
        borderColor: overdueCount > 0 ? "error.main" : undefined,
      }}
    >
      <CardActionArea
        onClick={() => navigate(`/transactions/${PIPELINE_ROUTE}`)}
        style={{
          textDecoration: "none",
          flexDirection: "column",
          flexGrow: 1,
          width: "100%",
        }}
      >
        <Box p={2} sx={{ flexGrow: 1 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={1}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <FilterAltIcon color="primary" />
              <Typography variant="h2" color="primary">
                Pipeline
              </Typography>
            </Box>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={1}
          >
            <Typography variant="body1">Entries: {entryCount || 0}</Typography>
            {overdueCount > 0 && (
              <Chip
                size="small"
                color="error"
                icon={<WarningAmberIcon />}
                label={`${overdueCount} overdue`}
              />
            )}
          </Box>

          <Box mt={2} display="flex" justifyContent="center">
            <Box
              sx={{
                height: 40,
                width: "100%",
                bgcolor: "rgba(0,0,0,0.04)",
                borderRadius: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="caption" color="text.secondary">
                View Details
              </Typography>
            </Box>
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  );
};

export default PipelineCard;
